<div id="nav">
    <section class="mobile-img">
        <img src="../../assets/img/ExcessMaterialLogo.png" alt="">
    </section>

    <section>
    <img src="../../assets/img/ExcessMaterialLogo.png" alt="">
    <form [formGroup]="SearchForm" action=#>
        <input type="text" value="" formControlName="search">
        <div class="mainSelect">
            <select class="groupSelect" name="cars" id="cars" formControlName="category">
                <option value="" selected disabled hidden>Select Category</option>
                <option value="free">Free</option> 
                <option value="all">All</option>
                <option value="interior">Interior Construction</option> 
                <option value="plumbing">Plumbing</option>      
                <option value="roofing">Roofing</option>       
                <option value="electrical">Electrical</option>
                <option value="yard">Yard</option>
          </select>
            <button *ngIf="empty; else elseButton" style="pointer-events: none;" disabled="true" (click)="searchItem()">Search</button>
            <ng-template #elseButton>
                <button (click)="searchItem()">Search</button>
            </ng-template>
        </div> 
    </form>
    </section>

    <app-about value="this is a test" style="display: none;" #about></app-about>
    <app-contact value="this is a test" style="display: none;" #contact></app-contact>

    <app-profile (reloadMainPostData)="grandParentX($event)" [currentPostPage]="profilePages['post']" [currentMessagePage]="profilePages['message']" style="display: none;" #profile *ngIf="(auth.isAuthenticated$ | async)" (pageTurnerLeft)="pageTurnedLeft($event)" (pageTurnerRight)="pageTurnedRight($event)" [totalM]="totalMessages" [totalP]="totalPosts"></app-profile>

    <div>
        <a (click)="valHandler('about')" #aboutButton>About</a>
        <a (click)="valHandler('contact')" #contactButton>Contact</a>
        <a (click)="valHandler('profile')" *ngIf="auth.isAuthenticated$ | async" #profileButton>Profile</a>
        <a *ngIf="(auth.isAuthenticated$ | async) === false" (click)="auth.loginWithRedirect()" #loggedOut>Log in</a>
        <a class="activated" *ngIf="auth.isAuthenticated$ | async" (click)="auth.logout()">Log out</a>
    </div>
</div>